import { getApiBaseUrlWithoutPath } from '../../config/environment';
import { getAuthHeaders } from './authUtils';

/**
 * Ask backend to notify the customer (in-app / email per server).
 * `POST /api/admin/orders/:orderId/notify-customer` — body:
 * `{ status, orderNumber?, message, title, userEmail?, adminNote? }`
 * If the route is missing (404), this fails silently so the admin UI still works.
 */
export async function tryNotifyCustomerOrderStatus({
  orderId,
  orderNumber,
  statusSlug,
  displayLabel,
  userEmail,
  adminNote,
}) {
  const id = encodeURIComponent(String(orderId || '').trim());
  if (!id) return false;
  const apiUrl = getApiBaseUrlWithoutPath();
  const num = orderNumber != null && String(orderNumber).trim() !== '' ? String(orderNumber).trim() : '';
  const message = num
    ? `Your order #${num} is now: ${displayLabel}.`
    : `Your order status is now: ${displayLabel}.`;

  try {
    const res = await fetch(`${apiUrl}/api/admin/orders/${id}/notify-customer`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        status: statusSlug,
        orderNumber: num || undefined,
        title: 'Order status update',
        message,
        userEmail: userEmail && String(userEmail).trim() ? String(userEmail).trim() : undefined,
        adminNote: adminNote && String(adminNote).trim() ? String(adminNote).trim() : undefined,
      }),
    });
    return res.ok;
  } catch {
    return false;
  }
}
